export default {
  getOrderCancelReasons: '/courier/api/v2/order/cancel/check',
  abortOrder: '/gateway/capp/order/courierOrderService/abortOrder',
  punishRule: '/courier/api/v2/order/cancel/punish/rule',
  beforeAbort: '/courier/api/v2/order/cancel/before/abort',
  priceCollect: '/v3/care/priceCollect'
}
